import Vue from 'vue';
import InfiniteScroll from 'vue-infinite-loading';

Vue.use(InfiniteScroll);
